// extracted by mini-css-extract-plugin
export default {"loadersmall":"LoaderSmall_loadersmall__lo5Kj"};